<app-topbar></app-topbar>
<p-toast></p-toast>
<main class="layout-container">
  <div class="layout-content-wrapper">
    <div class="layout-content">
      <div class="grid justify-content-center">
        <div class="col-12 md:col-12">
          <!-- Formulário de cadastro/edição fora do modal -->
          <p-card class="card custom-card" *ngIf="!displayEditModal">
            <ng-template pTemplate="header">
              <div class="card-header">
                <h3 class="card-title">Cadastro de Finalidade</h3>
              </div>
            </ng-template>
            <form [formGroup]="categoriaForm" (ngSubmit)="salvarCategoria()">
              <div class="mx-2 field">
                <label for="categoria_descricao" class="font-normal">
                  Descrição <span class="text-red-500">*</span>
                </label>
                <input id="categoria_descricao" placeholder="Descrição" class="mt-1" pInputText required
                  formControlName="categoria_descricao" />
              </div>
              <div class="mx-2 mt-4 field">
                <label for="status" class="font-normal">
                  Status <span class="text-red-500">*</span>
                </label>
                <div class="flex flex-wrap gap-3">
                  <div class="flex align-items-center">
                    <p-radioButton name="status" value="A" formControlName="status"
                      inputId="statusAtivo"></p-radioButton>
                    <label for="statusAtivo" class="ml-2">Ativo</label>
                  </div>
                  <div class="flex align-items-center">
                    <p-radioButton name="status" value="I" formControlName="status"
                      inputId="statusInativo"></p-radioButton>
                    <label for="statusInativo" class="ml-2">Inativo</label>
                  </div>
                </div>
              </div>
              <div class="mx-2 mt-3 flex gap-2">
                <button pButton pRipple type="submit" label="Salvar" class="bt-tema"></button>
                <p-button pRipple severity="secondary" label="Voltar" [routerLink]="'/painel'"></p-button>
              </div>
            </form>
          </p-card>

          <!-- Modal para edição (só permite alterar a descrição) -->
          <p-dialog header="Editar Categoria" [(visible)]="displayEditModal" modal="true" [closable]="false"
            [style]="{width: '30vw'}">
            <form [formGroup]="categoriaForm">
              <div class="p-field">
                <label for="categoria_descricao_modal">Descrição</label>
                <input id="categoria_descricao_modal" type="text" pInputText formControlName="categoria_descricao" />
              </div>
              <!-- Campo oculto para enviar o status atual -->
              <input type="hidden" formControlName="status" />
              <p-footer>
                <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary"
                  (onClick)="fecharModal()"></p-button>
                <span style="margin-left: 1rem;"></span>
                <p-button label="OK" icon="pi pi-check" styleClass="p-button-success"
                  (onClick)="confirmarEdicao()"></p-button>
              </p-footer>
            </form>
          </p-dialog>

          <!-- Card para exibição da lista de categorias -->
          <p-card class="md:mx-8 mx-2">
            <p-table [value]="categorias" 
            [paginator]="true"
            [rows]="10"
            [rowsPerPageOptions]="[5,10,20]"
            styleClass="p-datatable-gridlines p-datatable-striped"
              responsiveLayout="stack">
              <ng-template pTemplate="caption">
                Finalidades
              </ng-template>
              <ng-template pTemplate="header">
                <tr>
                  <th pSortableColumn="categoria_id" style="width: 20%; text-align: left">
                    Id <p-sortIcon field="categoria_id"></p-sortIcon>
                  </th>
                  <th pSortableColumn="categoria_descricao" style="width: 40%; text-align: center">
                    Descrição <p-sortIcon field="categoria_descricao"></p-sortIcon>
                  </th>
                  <th pSortableColumn="status" style="width: 20%; text-align: center">
                    Status <p-sortIcon field="status"></p-sortIcon>
                  </th>
                  <th style="width: 20%; text-align: center">Ação</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-cat>
                <tr>
                  <td><span class="p-column-title">Id</span>{{ cat.categoria_id }}</td>
                  <td class="text-center">
                    <span class="p-column-title">Descrição</span>{{ cat.categoria_descricao }}
                  </td>
                  <td class="text-center">
                    <span class="p-column-title">Status</span>{{ cat.status }}
                  </td>
                  <td class="text-center">
                    <button pButton icon="pi pi-pencil" iconPos="left" pTooltip="Editar" tooltipPosition="top" class="bt-tema mr-2"
                      styleClass="p-button-sm p-button-primary " (click)="abrirModalEdicao(cat)"></button>
                    <p-button *ngIf="cat.status === 'A'" icon="pi pi-trash" iconPos="left" pTooltip="Deletar" tooltipPosition="top"
                      styleClass="p-button-sm p-button-danger" (click)="excluirCategoria(cat.categoria_id)"></p-button>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </p-card>
        </div>
      </div>
    </div>
  </div>
</main>